<template>
<card class="job" @click="showJob" :set="dac = 'hello'" :footer="true">
<div class="media">
  <div class="media-left is-relative">
    <router-link :to="`/hirer/${job.companyId}`">
      <hv-image size="is-64x64" :src="companyImage" @click="onCompanyClick">
        <status-indicator :status="job.applicationStatus" :date="job.applicationUpdatedAt"/>
      </hv-image>
    </router-link>
  </div>
  <div class="media-content">
  </div>
  <div class="media-right has-text-right">
    <h2 class="is-5 m-b-12 status-label" v-if="job.status !== 'published'">{{$t("jobs.closed")}}</h2>
    <h2 v-else class="is-salary is-5 m-b-8" >
      <job-salary :job="job" />
    </h2>
    <h4 class="subtitle is-7 m-b-12">{{ getContract(job.jobTypeName) | capitalize }}</h4>
    <applicant-refrrer :job="job" />
  </div>
</div>
<h2 class="job-title text-overflow m-b-12">{{ job.title }}</h2>
<p class="company m-b-4"><router-link :to="`/hirer/${job.companyId}`">{{ job.companyName }}</router-link></p>
<job-location :locations="job.locations" :remote="job.isRemoteAvailable"></job-location>
<template slot="footer">
  <split-section>
    <template slot="left">
    <div class="segment" v-tooltip="rewardTooltip">
      <reward :isSourceJp="isSourceJp" :fiatReward="fiatReward" :min="rewardMin" :max="rewardMax" :currency="job.salaryCurrency" :rewardPercentage="job.rewardPercentage" :title="this.$t('jobs.rewardInHVT')" />
    </div>
    </template>
    <template slot="right">
    <div class="segment" v-tooltip="donateTooltip">
      <charity :jobSource="job.source" :fiatReward="job.fiatReward" :rewardPercentage="getJobReward" :minReward="rewardMin" :maxReward="rewardMax" :min="charityMin" :max="charityMax" :currency="job.salaryCurrency" />
    </div>
    </template>
  </split-section>
</template>
</card>
</template>

<script>
import _ from 'lodash'
import Card from '@/components/general/card'
import SplitSection from '@/components/general/split-section'
import HvImage from '@/components/general/image'
import Currency from '@/components/general/currency'
import GlobalData from '@/helpers/global-data'
import JobSalary from '@/components/general/job-salary'
import JobLocation from '@/components/jobs/job-locations'
import Reward from './reward.vue'
import Charity from './charity'
import RewardHelper from '@/helpers/reward'
import StatusIndicator from '@/components/jobs/job-status-indicator'
import ApplicantRefrrer from '@/components/jobs/applicant_and_referrer'
import JobHelper from '@/helpers/job'

export default {
  name: 'job',
  components: {
    Card,
    SplitSection,
    HvImage,
    GlobalData,
    Currency,
    JobSalary,
    JobLocation,
    Reward,
    Charity,
    StatusIndicator,
    ApplicantRefrrer
  },
  data () {
    return {
      minimum: null,
      maximum: null
    }
  },
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  computed: {
    fiatReward () {
      return this.job.hasOwnProperty('fiatReward') ? this.job.fiatReward : 0
    },
    isSourceJp () {
      return this.job.hasOwnProperty('source') && this.job.source === 'jp'
    },
    getJobReward () {
      return this.job.rewardPercentage
    },
    rewardTooltip () {
      return this.$t('jobs.rewardTooltip')
    },
    donateTooltip () {
      return this.$t('jobs.donateTooltip')
    },
    charityMin () {
      if (this.minimum) {
        return this.minimum.charity
      }
      return 0
    },
    charityMax () {
      if (this.maximum) {
        return this.maximum.charity
      }
      return 0
    },
    rewardMin () {
      if (this.minimum) {
        return this.minimum.user
      }
      return 0
    },
    rewardMax () {
      if (this.maximum) {
        return this.maximum.user
      }
      return 0
    },
    hasSalary () {
      return JobHelper.hasSalary(this.job)
    },
    companyImage () {
      return this.job.companyImageUrl || `/api/identicons/${this.job.companyId}`
    }
  },
  methods: {
    calcReward () {
      const rewardPercentage = this.job.rewardPercentage
      const maxReward = this.job.maxReward
      const minReward = this.job.minReward
      RewardHelper.calcPercentage(rewardPercentage)
      this.maximum = RewardHelper.calc(rewardPercentage, maxReward)
      this.minimum = RewardHelper.calc(rewardPercentage, minReward)
    },
    showJob () {
      this.$router.push({ name: 'JobsApply', params: { id: this.job.id } })
    },
    getContract (value) {
      if (value === 'contract') {
        return this.$t('jobs.roleContract')
      } else if (value === 'permanent') {
        return this.$t('jobs.rolePermanent')
      } else if (value === 'freelance') {
        return this.$t('jobs.roleFreelance')
      }
      return value
    },
    onCompanyClick () {
      this.$router.push(`/hirer/${this.job.companyId}`)
    }
  },
  filters: {
    capitalize (value) {
      return _.capitalize(value)
    }
  },
  mounted () {
    this.calcReward()
  }
}
</script>
<style lang="scss" scoped>
.job {
  cursor: pointer;
}

.job:hover {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
}
.segment {
  line-height: 1;
}
.job-title {
  font-size: 1.25rem;
  font-weight: 500;
}
p.company {
  font-size: 0.875rem;
  height: 16px;
  overflow: hidden;
  font-weight: bold;
  a {
    color: #111;
  }
}
p.is-7 {
  font-size: 0.75rem;
  margin-top: 0.25rem;
}
strong {
  font-size: 0.75rem;
  display: block;
  margin-bottom: 0.25rem;
}
.is-7 {
  margin-top: 0;
  color: #111;
  font-size: 0.75rem;
}
.status-label {
  color: #111111;
  font-weight: bold;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/job-card.vue